import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompanyUsersFilterEntity } from '../../domain/entities/CompanyUsersFilterEntity'

export class CompanyUsersFilterModel extends CompanyUsersFilterEntity {
  mealTierId?: number

  constructor(dataDto: CompanyUsersFilterEntity) {
    super()
    mapEntityProperties<CompanyUsersFilterModel>(this, dataDto, {
      exclude: ['mealTier'],
      map: {
        mealTierId: dataDto.mealTier?.id,
        companyId: dataDto.company?.id
      }
    })
  }
}
